var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 112 32",
    width: 112,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 18.4829,
    x2: 5.95529,
    y1: 7.81463,
    y2: 20.3423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 27.4664,
    x2: 9.40409,
    y1: 16.2437,
    y2: 16.2437
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#ffa500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 20.743,
    x2: 3.75454,
    y1: 17.9567,
    y2: 34.9451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 7.65755,
    x2: 15.2437,
    y1: 1.44486,
    y2: 9.0309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: 32,
    rx: 5.53846,
    width: 112
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.7688 8.31445c0 .67282-.1682 1.26154-.5887 1.68205-.5046.5046-1.0933.7569-1.8503.7569-.7569 0-1.3456-.2523-1.8502-.7569-.5046-.50462-.7569-1.09333-.7569-1.85026 0-.75692.2523-1.34564.7569-1.85025.5046-.50462 1.0933-.75693 1.8502-.75693.3364 0 .6729.08411 1.0093.25231.3364.16821.5887.33641.7569.58872l-.4205.42051c-.3364-.42051-.7569-.58872-1.3457-.58872-.5046 0-1.0092.16821-1.3456.58872-.4205.33641-.5887.84103-.5887 1.42975 0 .58871.1682 1.09333.5887 1.42974s.841.58871 1.3456.58871c.5888 0 1.0093-.1682 1.4298-.58871.2523-.25231.4205-.58872.4205-1.00923h-1.8503v-.58872h2.439z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.168205
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.6374 6.21128h-2.2707v1.59795h2.1025v.58871h-2.1025v1.59795h2.2707v.67281h-2.9436v-5.04614h2.9436z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.168205
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.4136 10.6687h-.6728v-4.45742h-1.4298v-.58872h3.5323v.58872h-1.4297z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.168205
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.2822 10.6687v-5.04614h.6728v5.04614z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.168205
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.8145 10.6687h-.6728v-4.45742h-1.4298v-.58872h3.4482v.58872h-1.4297v4.45742z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.168205
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.8041 9.99601c-.5046.50459-1.0933.75689-1.8502.75689-.757 0-1.3457-.2523-1.8503-.75689-.5046-.50461-.7569-1.09333-.7569-1.85026 0-.75692.2523-1.34564.7569-1.85025.5046-.50462 1.0933-.75693 1.8503-.75693.7569 0 1.3456.25231 1.8502.75693.5046.50461.7569 1.09333.7569 1.85025 0 .75693-.2523 1.34565-.7569 1.85026zm-3.1959-.42051c.3364.33641.841.5887 1.3457.5887.5046 0 1.0092-.16819 1.3456-.5887.3364-.33641.5887-.84103.5887-1.42975 0-.58871-.1682-1.09333-.5887-1.42974-.3364-.33641-.841-.58872-1.3456-.58872-.5047 0-1.0093.16821-1.3457.58872-.3364.33641-.5887.84103-.5887 1.42974 0 .58872.1682 1.09334.5887 1.42975z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.168205
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.4858 10.6687v-5.04614h.757l2.4389 3.95282v-1.00923-2.94359h.6729v5.04614h-.6729l-2.6071-4.12101v1.00923 3.11178z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.168205
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.8957 17.6723c-1.8156 0-3.2529 1.3617-3.2529 3.2529 0 1.8156 1.4373 3.253 3.2529 3.253 1.8157 0 3.253-1.3617 3.253-3.253 0-1.9669-1.4373-3.2529-3.253-3.2529zm0 5.1442c-.9834 0-1.8156-.8322-1.8156-1.9669 0-1.1348.8322-1.9669 1.8156-1.9669.9835 0 1.8157.7565 1.8157 1.9669 0 1.1347-.8322 1.9669-1.8157 1.9669zm-7.0354-5.1442c-1.8156 0-3.253 1.3617-3.253 3.2529 0 1.8156 1.4374 3.253 3.253 3.253s3.2529-1.3617 3.2529-3.253c0-1.9669-1.4373-3.2529-3.2529-3.2529zm0 5.1442c-.9835 0-1.8156-.8322-1.8156-1.9669 0-1.1348.8321-1.9669 1.8156-1.9669.9834 0 1.8156.7565 1.8156 1.9669 0 1.1347-.8322 1.9669-1.8156 1.9669zm-8.3972-4.1608v1.3617h3.253c-.0757.7565-.3783 1.3617-.7565 1.74-.4539.4539-1.2104.9834-2.4965.9834-2.0425 0-3.5555-1.5886-3.5555-3.6312 0-2.0425 1.5886-3.6312 3.5555-3.6312 1.0591 0 1.8913.4539 2.4965.9835l.9834-.9835c-.8321-.7565-1.8912-1.3617-3.4042-1.3617-2.7234 0-5.0686 2.2695-5.0686 4.9929s2.3452 4.9929 5.0686 4.9929c1.513 0 2.5721-.4539 3.4799-1.4373.9078-.9078 1.2104-2.1939 1.2104-3.1773 0-.3026 0-.6052-.0757-.8322zm34.3452 1.0591c-.3026-.7565-1.0591-2.0425-2.7234-2.0425s-3.026 1.286-3.026 3.2529c0 1.8156 1.3617 3.253 3.1773 3.253 1.4373 0 2.3451-.9078 2.6477-1.4374l-1.0591-.7565c-.3782.5296-.8321.9078-1.5886.9078s-1.2104-.3026-1.5887-.9834l4.3121-1.8156zm-4.3877 1.0591c0-1.2104.9834-1.8912 1.6643-1.8912.5295 0 1.0591.3026 1.2104.6808zm-3.5556 3.1017h1.4374v-9.4563h-1.4374zm-2.2695-5.5225c-.3782-.3782-.9834-.7565-1.7399-.7565-1.5887 0-3.1017 1.4374-3.1017 3.253s1.4374 3.1773 3.1017 3.1773c.7565 0 1.3617-.3783 1.6643-.7565h.0756v.4539c0 1.2104-.6808 1.8912-1.7399 1.8912-.8322 0-1.4374-.6052-1.5887-1.1347l-1.2104.5295c.3783.8322 1.2861 1.8913 2.8747 1.8913 1.6643 0 3.026-.9835 3.026-3.3286v-5.7494h-1.3617zm-1.6643 4.4634c-.9834 0-1.8156-.8322-1.8156-1.9669 0-1.1348.8322-1.9669 1.8156-1.9669.9835 0 1.74.8321 1.74 1.9669 0 1.1347-.7565 1.9669-1.74 1.9669zm18.4586-8.3972h-3.4042v9.4563h1.4373v-3.5556h1.9669c1.5887 0 3.1017-1.1347 3.1017-2.9503s-1.513-2.9504-3.1017-2.9504zm.0757 4.539h-2.0426v-3.2529h2.0426c1.0591 0 1.6643.9078 1.6643 1.5886-.0757.8322-.6809 1.6643-1.6643 1.6643zm8.6998-1.3617c-1.0591 0-2.1183.4539-2.4965 1.4374l1.2861.5295c.3026-.5295.7565-.6808 1.286-.6808.7565 0 1.4374.4539 1.513 1.2104v.0756c-.2269-.1513-.8321-.3782-1.4373-.3782-1.3618 0-2.7235.7565-2.7235 2.1182 0 1.286 1.1348 2.1182 2.3452 2.1182.9835 0 1.4374-.4539 1.8156-.9078h.0757v.7565h1.3617v-3.6312c-.1513-1.6643-1.4374-2.6478-3.026-2.6478zm-.1513 5.2199c-.454 0-1.1348-.227-1.1348-.8322 0-.7565.8321-.9834 1.513-.9834.6052 0 .9078.1513 1.2861.3026-.1513.9078-.9078 1.513-1.6643 1.513zm7.9432-4.9929-1.5886 4.0851h-.0757l-1.6643-4.0851h-1.513l2.4965 5.7494-1.4374 3.1773h1.4374l3.8581-8.9267zm-12.7092 6.052h1.4373v-9.4563h-1.4373z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.97333 6.91162c-.22394.22394-.37323.59718-.37323 1.04506v16.49712c0 .4478.14929.8211.37323 1.045l.07467.0747 9.2563-9.2563v-.0747-.0746z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.3647 19.4524-3.0605-3.0605v-.1493-.0746l3.0605-3.0606.0747.0747 3.6577 2.0901c1.0451.5972 1.0451 1.5676 0 2.1648z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.4397 19.3779-3.1351-3.1352-9.33097 9.3309c.37327.3732.89577.3732 1.56757.0746z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22.4397 13.1076-10.8985-6.19571c-.6718-.37324-1.1943-.29859-1.56757.07465l9.33097 9.25626z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22.3651 19.3042-10.8239 6.1211c-.5972.3732-1.1197.2986-1.4929 0l-.07467.0746.07467.0747c.3732.2986.8957.3732 1.4929 0z",
    fill: "#000",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m9.97388 25.4249c-.22394-.2239-.29859-.5971-.29859-1.045v.0746c0 .4479.1493.8212.37321 1.0451v-.0747z",
    fill: "#000",
    opacity: 0.12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m26.0971 17.2131-3.7324 2.0901.0747.0747 3.6577-2.0902c.5225-.2986.7465-.6718.7465-1.045 0 .3732-.2986.6718-.7465.9704z",
    fill: "#000",
    opacity: 0.12
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m11.541 6.98635 14.5562 8.28585c.4479.2986.7465.5972.7465.9704 0-.3732-.2239-.7465-.7465-1.045l-14.5562-8.2859c-1.0451-.59718-1.8662-.07465-1.8662 1.11971v.07465c0-1.19436.8211-1.71689 1.8662-1.11971z",
    fill: "#fff",
    opacity: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDownload);
export default __webpack_public_path__ + "static/media/GoogleDownload.48a5e178e58bb168d544c38b015d2044.svg";
export { ForwardRef as ReactComponent };